import { render, staticRenderFns } from "./TendenciaHistorica.vue?vue&type=template&id=59c0d65a&scoped=true&"
import script from "./TendenciaHistorica.vue?vue&type=script&lang=js&"
export * from "./TendenciaHistorica.vue?vue&type=script&lang=js&"
import style0 from "./TendenciaHistorica.vue?vue&type=style&index=0&id=59c0d65a&scoped=true&lang=css&"
import style1 from "./TendenciaHistorica.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c0d65a",
  null
  
)

export default component.exports